export default "__VITE_ASSET__Bps48cLn__"